import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  smPaperScrollPaper: {
    minHeight: '420px',
    maxHeight: '750px',
  },
  mdPaperScrollPaper: {
    minHeight: '500px',
    maxHeight: '750px',
  },
  statusContainer: {
    display: 'flex',
    minHeight: '200px',
  },
  progress: {
    margin: 'auto',
  },
  bankName: {
    paddingLeft: 18,
    paddingBottom: 10,
    color: '#ffffff',
  },
  nameLine: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'flex-start',
    alignContent: 'center',
    paddingLeft: 28,
    zIndex: '1',
    transform: 'translate(0px, 24px)',
  },
  iconBank: {
    backgroundColor: theme.palette.greyScale[5],
    border: '1px solid rgba(151,151,151,0.4)',
    height: '64px',
    width: '102px',
  },
  iconFds: {
    height: '64px',
    width: '102px',
  },
  iconPlaid: {
    height: '64px',
    width: '64px',
  },
  names: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  titleName: {
    color: '#FFFFFF',
    paddingLeft: 18,
  },
  colorBar: {
    minHeight: '100px',
    width: '100%',
    backgroundColor: theme.palette.color8.opacity100,
  },
}));

// seems outdated but leaving in case Ken wants to preserve logic

// function arrowGenerator(color) {
//   return {
//     '&[x-placement*="bottom"] $arrow': {
//       top: 0,
//       left: 0,
//       marginTop: '-0.95em',
//       width: '3em',
//       height: '1em',
//       '&::before': {
//         borderWidth: '0 1em 1em 1em',
//         borderColor: `transparent transparent ${color} transparent`,
//       },
//     },
//     '&[x-placement*="top"] $arrow': {
//       bottom: 0,
//       left: 0,
//       marginBottom: '-0.95em',
//       width: '3em',
//       height: '1em',
//       '&::before': {
//         borderWidth: '1em 1em 0 1em',
//         borderColor: `${color} transparent transparent transparent`,
//       },
//     },
//     '&[x-placement*="right"] $arrow': {
//       left: 0,
//       marginLeft: '-0.95em',
//       height: '3em',
//       width: '1em',
//       '&::before': {
//         borderWidth: '1em 1em 1em 0',
//         borderColor: `transparent ${color} transparent transparent`,
//       },
//     },
//     '&[x-placement*="left"] $arrow': {
//       right: 0,
//       marginRight: '-0.95em',
//       height: '3em',
//       width: '1em',
//       '&::before': {
//         borderWidth: '1em 0 1em 1em',
//         borderColor: `transparent transparent transparent ${color}`,
//       },
//     },
//   };
// }
